function formateDate(date) {
    var d = new Date(date)
    var year = d.getFullYear()
    var month = d.getMonth()+1
    var day = d.getDate()
    var hour = d.getHours()
    var min = d.getMinutes()
    var sec = d.getSeconds()
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    if (hour.length < 2) hour = '0' + hour;
    if (min.length < 2) min = '0' + min;
    if (sec.length < 2) sec = '0' + sec;
    return [year, month, day].join('-')+' '+[hour,min,sec].join(':');
}

function forMateTime(time,onlyDate){//带T类型日期转换
    if(time== null||time == undefined)return
    let arr = time.split("T");
    let d1 = arr[0];
    let darr = d1.split("-");
    let t = arr[1];
    let tarr = t.split(".000");
    let marr = tarr[0].split(":");
    let dd = parseInt(darr[0]) + "/" + parseInt(darr[1]) + "/" + parseInt(darr[2]) + " " + parseInt(marr[0]) + ":" + parseInt(marr[1]) + ":" + parseInt(marr[2]);
    return formatDateTime(dd,onlyDate);
}

function formatDateTime(date,onlyDate) {
    let time = new Date(Date.parse(date));
    time.setTime(time.setHours(time.getHours() + 8));
    let Y = time.getFullYear() + '-';
    let M = addZero(time.getMonth() + 1) + '-';
    let D = addZero(time.getDate()) + ' ';
    let h = addZero(time.getHours()) + ':';
    let m = addZero(time.getMinutes()) + ':';
    let s = addZero(time.getSeconds());
    if(onlyDate)return Y + M + D
    return Y + M + D + h + m + s;
    // }
}

// 数字补0操作
function addZero(num) {
    return num < 10 ? '0' + num : num;
}

function setCookie(name,value) {
    var Days = 1;
    var exp = new Date();
    exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
    document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString() + ";path:/";
}

function getCookie(objName) {
    var arrStr = document.cookie.split("; ");
    for (var i = 0; i < arrStr.length; i++) {
        var temp = arrStr[i].split("=");
        if (temp[0] == objName) {
            return decodeURI(temp[1]);
        }
    }
}
function getUrlKey() {
    var url = window.location.href; //获取当前url
    console.log('url.shi ',url)
    var dz_url = url.split("#")[0]; //获取#/之前的字符串
    var cs = dz_url.split("?")[1]; //获取?之后的参数字符串
    var cs_arr = cs&&cs.split("&")||[]; //参数字符串分割为数组
    var obj = {};

    for (var i = 0; i < cs_arr.length; i++) {
      //遍历数组，拿到json对象
      obj[cs_arr[i].split("=")[0]] = cs_arr[i].split("=")[1];
    }

    return obj
  }
  function chat2Ascii(str){
    console.log('传入的值',str)
    var char = ''
    for(var i =0 ;i<str.length;i++){
        char+=str[i].charCodeAt()
    }
    return char
  }

 function hasLogin() {
    let token = localStorage.getItem('token');
    let tokenType = localStorage.getItem('tokenType')
    let email = localStorage.getItem('email')
    return token!=null&&email!=null&&tokenType!=null
}
export {formateDate,forMateTime,setCookie,getCookie,getUrlKey,chat2Ascii,hasLogin}